export async function processFormExtraction(params: {
  file: File;
  formType?: string;
  municipalityId?: number;
}) {
  const form = new FormData();
  form.append("file", params.file);
  if (params.formType) form.append("form_type", params.formType);
  if (params.municipalityId) form.append("municipality_id", String(params.municipalityId));

  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";

  const resp = await fetch("/api/v1/form_extraction/process", {
    method: "POST",
    headers: { "X-CSRF-Token": csrf },
    body: form,
  });

  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data.error || `Request failed with ${resp.status}`);
  }

  return resp.json() as Promise<{
    extracted: Record<string, unknown>;
    usage?: { num_pages?: number; num_fields?: number };
    s3_key?: string;
    id?: number;
    created_at?: string;
  }>;
}

export async function getFormTypes() {
  const resp = await fetch("/api/v1/form_extraction/form_types");
  if (!resp.ok) {
    throw new Error(`Request failed with ${resp.status}`);
  }
  return resp.json() as Promise<{ form_types: string[] }>;
}
